import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { GraduationCap, Briefcase } from 'lucide-react';

export default function ApplyTypePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const runId = location.state?.runId;
  const result = location.state?.result;

  return (
    <div className="flex-1 flex items-center justify-center px-4" data-testid="apply-type-page">
      <div className="animate-fade-up max-w-md w-full text-center">
        <h2 className="font-outfit font-bold text-2xl sm:text-3xl text-white mb-2">Bewerben</h2>
        <p className="text-[#9CA3AF] mb-8">Wähle dein Einstiegslevel</p>

        <div className="grid gap-4">
          <Button
            onClick={() => navigate('/apply/form', { state: { applicantType: 'azubi', runId, result } })}
            className="w-full h-20 bg-white/5 hover:bg-[#3B82F6]/15 border border-white/10 hover:border-[#3B82F6]/40 text-white rounded-xl transition-all"
            data-testid="apply-azubi-btn"
          >
            <GraduationCap className="w-7 h-7 mr-3 text-[#3B82F6]" />
            <div className="text-left">
              <p className="font-outfit font-bold text-lg">Auszubildende/r</p>
            </div>
          </Button>

          <Button
            onClick={() => navigate('/apply/form', { state: { applicantType: 'profi', runId, result } })}
            className="w-full h-20 bg-white/5 hover:bg-[#8B5CF6]/15 border border-white/10 hover:border-[#8B5CF6]/40 text-white rounded-xl transition-all"
            data-testid="apply-profi-btn"
          >
            <Briefcase className="w-7 h-7 mr-3 text-[#8B5CF6]" />
            <div className="text-left">
              <p className="font-outfit font-bold text-lg">Berufserfahren</p>
            </div>
          </Button>
        </div>

        <Button variant="ghost" onClick={() => navigate(-1)} className="mt-6 text-[#9CA3AF] hover:text-white" data-testid="apply-back-btn">
          Zurück
        </Button>
      </div>
    </div>
  );
}
